import React from "react";
import AddNewRecruit from "../Recruits/AddNewRecruit";

function AddNewRecruitPage() {
  return (
    <div>
      <AddNewRecruit />
    </div>
  );
}

export default AddNewRecruitPage;
